import { CaptureStatusEvent } from 'domain/capture-status'

/**
 * Whether an incoming "capture-status" event belongs to the currently
 * authenticated client. The hub broadcasts to all connections, so the dashboard
 * must ignore events from other tenants. Guards multi-tenant correctness.
 */
export const isCaptureStatusForClient = (
  event: Pick<CaptureStatusEvent, 'clientId'> | null | undefined,
  clientId: string | null | undefined
): boolean => {
  if (!clientId || !event?.clientId) {
    return false
  }
  return event.clientId === clientId
}
